/** Client Challenges helpers (labels shared with server semantics). */

export const CHALLENGE_MODE_OPTIONS: Array<{ id: string; label: string }> = [
  { id: "normal", label: "Normal" },
  { id: "wasd", label: "WASD" },
  { id: "superdot", label: "Superdot" },
  { id: "roulette", label: "Roulette" },
  { id: "highway", label: "Highway" },
  { id: "darkness", label: "Darkness" },
  { id: "mirror", label: "Mirror" },
  { id: "snake", label: "Snake" },
  { id: "combo", label: "Combo" },
  { id: "colorrush", label: "Color Rush" },
  { id: "heat", label: "Heat" },
  { id: "hunter", label: "Hunter" },
  { id: "pop", label: "POP" },
  { id: "counter", label: "Counter" },
  { id: "aim", label: "AIM" },
  { id: "hook", label: "Hook" },
  { id: "tilt", label: "Tilt" },
  { id: "orbit", label: "Orbit" },
  { id: "delay", label: "Delay" },
  { id: "progression", label: "Progression" },
  { id: "speedrun", label: "SpeedRun" },
  { id: "penalty", label: "Golf" },
];

export const CHALLENGE_REWARD_AMOUNTS = [
  500, 1000, 1500, 2000, 2500, 3000, 3500, 4000, 4500, 5000, 5500, 6000, 6500, 7000, 7500, 8000,
  8500, 9000, 9500, 10000,
] as const;

export type ChallengeDayStatus = "available" | "success" | "failed" | "in_progress";

export type ChallengeAttempt = {
  dateKey: string;
  templateId: string;
  modeId: string;
  metric: "score" | "time";
  goalValue: number;
  token: string;
  modeLabel: string;
  /** Official SpeedRun / Golf level when applicable. */
  levelIndex?: number | null;
};

export type ChallengeStatusResponse = {
  available: boolean;
  status: ChallengeDayStatus;
  today: string | null;
  timeZone: string;
  dayEndsAt: string | null;
  serverNow: string;
  active: ChallengeAttempt | null;
  activeTemplateCount?: number;
  lobbyTips?: ChallengeLobbyTip[];
  message?: string;
};

export type ChallengeLobbyTip = {
  id: string;
  text: string;
  posX: number;
  posY: number;
  /** blue = available square, red = locked, both = either */
  squareState: "blue" | "red" | "both" | string;
  holdSeconds: number;
  durationSeconds: number;
  pauseCountdown: boolean;
  hideCountdown: boolean;
  active?: boolean;
  sortOrder?: number;
};

export function challengeModeNeedsLevel(modeId?: string | null): boolean {
  return modeId === "speedrun" || modeId === "penalty";
}

export function formatChallengeGoal(
  metric: "score" | "time",
  goalValue: number,
  modeId?: string,
  levelIndex?: number | null,
): string {
  if (challengeModeNeedsLevel(modeId)) {
    const lv = Math.max(1, Math.floor(Number(levelIndex) || 0));
    const kind = modeId === "penalty" ? "Golf" : "SpeedRun";
    const secs = Math.max(1, Math.floor(goalValue));
    const levelBit = lv >= 1 ? ` level ${lv}` : " level";
    return `Finish ${kind}${levelBit} in ${secs}s`;
  }
  if (metric === "time") return `Goal: ${Math.max(1, Math.floor(goalValue))}s`;
  if (modeId === "progression") return `Goal: Level ${Math.max(1, Math.floor(goalValue))}`;
  return `Goal: ${Math.max(1, Math.floor(goalValue))} score`;
}
